document.addEventListener("DOMContentLoaded", function () {
  const tabLinks = document.querySelectorAll('.tabs-nav');
  const tabContents = document.querySelectorAll('.product__datatable');

  tabLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      tabLinks.forEach((l) => l.classList.remove("active"));
      tabContents.forEach((c) => (c.style.display = "none"));

      this.classList.add("active");
      console.log('data-id = ' + this.getAttribute("data-id"));
      const target = document.querySelector('#' + this.getAttribute("data-id"));
      if (target) target.style.display = "block";
    });
  });
});